export const TRACKING_KEY_SAVE_FOR_LATER = "tracking.productList.saveForLater";
export const TRACKING_KEY_PRODUCT_CLICK = "tracking.productList.productClick";
export const TRACKING_KEY_LOYALTY_OPT_IN_CLICK =
  "tracking.productList.loyalty.optInClick";
export const TRACKING_KEY_LOYALTY_OPT_IN_REJECT =
  "tracking.productList.loyalty.reject";
export const TRACKING_CONTEXT_SAVE_FOR_LATER = "saveForLater";
export const TRACKING_CONTEXT_PRODUCT_CLICK = "productTile";
export const TRACKING_WORD_DELIMITER = "%$";
export const TRACKING_CATEGORY_PAGE_TYPE = "category";
export const TRACKING_CATEGORY_BRAND_TYPE = "brand";
export const TRACKING_BRAND_DIRECTORY_PAGE_TYPE = "brand_directory";
